import React from "react";
import { getCalendarDay } from "../../calendar/utils";
import { TweakProvider } from "../../utils/TweakProvider";
import { Mattins } from "../pray/Mattins";

export const MattinsToday: React.FC<{}> = () => {
    const dateTime = new Date();
    if (dateTime.getHours() < 3) {
        dateTime.setDate(dateTime.getDate() - 1);
    }

    const date = dateTime.getDate();
    const month = dateTime.getMonth() + 1;
    const year = dateTime.getFullYear();

    const day = getCalendarDay(year, month, date, true);

    return (
        <TweakProvider initialState={{}}>
            <Mattins day={day} isToday={true} />
        </TweakProvider>
    );
};
